import React, { useState, useEffect } from "react";
import Wrappers from "../shared/Wrappers";
import Header from "./Header";
import UserTable from "./UserTable";
import User from "./data/user.json";
import {
  GetAllAgents,
  GetComePermissions,
} from "../../../services/admin/agents";
import Loader from "../../shared/loader";
import { useSelector } from "react-redux";
import NotFoundIcon from "../../shared/NotFoundIcon";

const AgentsMain = () => {
  const [loading, setLoading] = useState(false);
  const [AllData, setAllData] = useState([]);
  const [CurrentPage, setCurrentPage] = useState(1);
  const [SearchInputValue, setSearchInputValue] = useState("");

  const [UsersData, SetUsersData] = useState([]);

  const TableHeadData = [
    { title: "ID", val: "id" },
    { title: "Name", val: "name" },
    { title: "Email", val: "email" },
    { title: "Permissions", val: "Permissions" },
  ];

  useEffect(() => {
    handleFetchAllAgents();
  }, [SearchInputValue, CurrentPage]);

  const handleFetchAllAgents = async () => {
    const Search = SearchInputValue || "";
    const Page = CurrentPage || 1;
    await GetAllAgents(setLoading, setAllData, Search, Page);
  };

  useEffect(() => {
    if (AllData && AllData?.data?.length > 0) {
      const modifiedData = AllData?.data?.map((values) => {
        const id = values?.slug;
        const name = values?.name;
        const email = values?.email;
        const Permissions = GetComePermissions(values?.permissions);

        // const { stops, ...modifiedValues } = values;

        return {
          // ...modifiedValues,
          id,
          name,
          email,
          Permissions,
        };
      });

      // Update the OrdersData state with the modified array
      SetUsersData(modifiedData || []);
    }
  }, [AllData]);

  // == update the Permissions on runtime

  const UpdatedAgent = useSelector(
    (state) => state?.adminagents?.UpdatedAgentValue
  );

  useEffect(() => {
    if (UpdatedAgent) {
      const updatedIndex = UsersData.findIndex((e) => e.id === UpdatedAgent.id);
      if (updatedIndex !== -1) {
        SetUsersData((prevUsersData) =>
          prevUsersData.map((user, index) =>
            index === updatedIndex ? UpdatedAgent : user
          )
        );
      }
    }
  }, [UpdatedAgent]);

  // == End update the Permissions on runtime

  return (
    <Wrappers>
      {loading && <Loader />}
      <Header
        SearchInputValue={SearchInputValue}
        setSearchInputValue={setSearchInputValue}
        UsersData={UsersData}
        SetUsersData={SetUsersData}
      />

      {!loading && (
        <>
          {UsersData && UsersData?.length > 0 ? (
            <>
              <UserTable
                TableHeadData={TableHeadData}
                BodyData={UsersData}
                Last_page={AllData?.last_page}
                total_pages={AllData?.total_pages}
                CurrentPage={CurrentPage}
                setCurrentPage={setCurrentPage}
              />
            </>
          ) : (
            !loading && <NotFoundIcon MT="20" IconWidth="10" />
          )}
        </>
      )}
    </Wrappers>
  );
};

export default AgentsMain;
